//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ediSources', {
//        templateUrl: 'views/components/views/ediSources/ediSources.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ediSourcesService', function (stateService, ediSourcesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//    			itemsListEdiSources: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION

//            async function loadEdiSources() {
//                vm.model.itemsListEdiSources = await ediSourcesService.listEdiSources();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'edisource':
//                        go({ edi_source_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdiSources();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
